/**
 * Transform an API Applied Promotion Code object to a Promotion Code
 *
 * @param promotionCode The API PromotionCode object
 * @returns PromotionCode
 */
export function transformPromotionCode(promotionCode: ApiSchema['PromotionCode']): PromotionCode {
    return {
        code: promotionCode.code ?? '',
        name: promotionCode.name ?? '',
        displayName: promotionCode.displayName ?? '',
        issuer: promotionCode.issuer ?? undefined,
    };
}
